import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface CustomerLeadOrigin {
  lead_id: string;
  list_name: string;
  converted_at: string | null;
}

/** Hvor kunden kom fra, når den ble opprettet fra et lead (RPC customer_lead_origin). null = ikke fra lead. */
export function useCustomerLeadOrigin(customerId: string | undefined, options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["customer-lead-origin", customerId],
    queryFn: async (): Promise<CustomerLeadOrigin | null> => {
      const { data, error } = await supabase.rpc("customer_lead_origin", { p_customer_id: customerId! });
      if (error) throw new Error(error.message);
      const rows = (data ?? []) as CustomerLeadOrigin[];
      return rows[0] ?? null;
    },
    enabled: !!customerId && (options.enabled ?? true),
    staleTime: 5 * 60 * 1000,
  });
}
